/**
 * 操作dom的一些公共方法
 */
import { LOADING_DOM } from './loading'
import { RECORD_DOM } from './record'
import { SEARCH_DOM } from './search'
import { COMMENT_DOM } from './comment'
import { DISCUSS_DOM } from './discuss'
import { FAMOUS_DOM } from './famous'

var DOM = {
    // 禁止滚动的函数
    stopTouch(e) { e.preventDefault(); },
    // 禁止滚动
    setStopTouch() {
        document.body.addEventListener('touchmove', DOM.stopTouch, { passive: false, capture: true })
    },
    // 恢复滚动
    resetStopTouch() {
        document.body.removeEventListener('touchmove', DOM.stopTouch, { passive: false, capture: true })
    },
    // 设置document.title
    setDocumentTitle(title) {
        document.title = title;
    },
    /**
     * 根据样式隐藏页面(显示二级页面的时候用来隐藏底部页面)
     * @param {样式名} className 
     */
    hideParentPageByClassName(className) {
        var pageDiv = document.getElementsByClassName(className)[0], childNodesArr = [];
        if(pageDiv) {
            pageDiv.style.width = innerWidth + 'px';
            pageDiv.style.height = innerHeight + 'px';
            
            childNodesArr = pageDiv.childNodes;
        }
        childNodesArr.forEach(elementNode => {
            if(elementNode && elementNode.className && elementNode.className.indexOf('layout-sub-page') < 0){
                elementNode.style.display = 'none';
            }
        });
    },
    /**
     * 根据样式隐藏页面(显示二级页面的时候用来隐藏底部页面)
     * @param {样式名} className 
     */
    showParentPageByClassName(className) {
        var pageDiv = document.getElementsByClassName(className)[0], childNodesArr = [];
        if(pageDiv) {
            pageDiv.style = '';
            childNodesArr = pageDiv.childNodes;
        }
        childNodesArr.forEach(elementNode => {
            if(elementNode && elementNode.className && elementNode.className.indexOf('layout-sub-page') < 0){
                elementNode.style = '';
            }
        });
    },
    // 选择弹框
    updateChooseItemPopPos(pos, basicPos, itemSize) {
        var newPos = {};
        newPos.x = basicPos.x + pos[0] * itemSize.width;
        newPos.y = basicPos.y + pos[1] * itemSize.height;
        var triangleIcon = document.getElementsByClassName('com-choose-triangle')[0];
        var popDiv = document.getElementsByClassName('com-choose-item-popup')[0];
        var zIndex = popDiv.style.zIndex;
        // console.log('updateChooseItemPopPos----', pos, newPos, zIndex);

        triangleIcon.style = 'left: ' + newPos.x + 'px; top: ' + newPos.y + 'px; z-index: ' + zIndex;
        popDiv.style = 'top: ' + (newPos.y + parseInt(popDiv.clientHeight / 2) + 25) + 'px; z-index: ' + zIndex;
    },
    setHiddenByClassName(className) {
        var dom = document.getElementsByClassName(className)[0];
        if(dom){
            dom.style = "height: 0; overflow: hidden;"
        }
    },
    // 添加div的隐藏
    setDisplayNoneByClassName(className) {
        var dom = document.getElementsByClassName(className)[0];
        if(dom){
            dom.style = "display: none;"
        }
    },
    resetLineHeightByClassName(className) {
        var box = document.getElementsByClassName(className)[0];
        box.style = 'line-height:' + box.clientHeight/box.childElementCount + 'px';
    },
    // 删除div的style设置
    removeStyleByClassName(className) {
        var dom = document.getElementsByClassName(className)[0];
        if(dom){
            dom.style = ""
        }
    },
    // 原生JS获取siblings相邻元素
    getSiblingElems(elem) {
        var nodes = [];
        var _elem = elem;
        while ((elem = elem.previousElementSibling)) {
            if (elem.nodeType == 1) {
                nodes.push(elem);
            }
        }
        var elem = _elem;
        while ((elem = elem.nextElementSibling)) {
            if (elem.nodeType == 1) {
                nodes.push(elem);
            }
        }
        return nodes;
    },
    // 隐藏主页面样式
    hidePageByClassName(className) {
        var dom = document.getElementsByClassName(className)[0];
        if(dom){
            dom.style.display = 'none'
        }
    },
    showPageByClassName(className) {
        var dom = document.getElementsByClassName(className)[0];
        if(dom){
            dom.style.display = ''
        }
    }
}
export {
    DOM, LOADING_DOM, RECORD_DOM, SEARCH_DOM, COMMENT_DOM, DISCUSS_DOM, FAMOUS_DOM
}